import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OrderSheetList from '../../../components/projectmng/order_sheet_sent/OrderSheetList';
import {
  listOrderSheetSents,
  unloadOrderSheets,
} from '../../../modules/projectModule/orderSheetSents';

const OrderSheetListContainer = ({ project, onRowClick }) => {
  const dispatch = useDispatch();
  const { orderSheets, error, loading } = useSelector(
    ({ projectModule, loading }) => ({
      orderSheets: projectModule.orderSheetSents.orderSheets,
      error: projectModule.orderSheetSents.error,
      loading: loading['project/LIST_ORDER_SHEET_SENT'],
    }),
  );

  useEffect(() => {
    if (project) {
      dispatch(listOrderSheetSents(project.prjUuid));
    }
    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadOrderSheets());
    };
  }, [dispatch, project]);

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'spoUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'prjUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'orderSheetNo',
        headerName: '발주 번호',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'sellPartnerUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
      },
      {
        field: 'sellPartnerNm',
        headerName: '매입처',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'center',
      },

      {
        field: 'sheetCrtDate',
        headerName: '발주일자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'sheetUsrNm',
        headerName: '담당자',
        minWidth: 120,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
      {
        field: 'sheetTotal',
        headerName: '발주금액',
        minWidth: 120,
        flex: 0.8,
        type: 'number',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },

      {
        field: 'useYn',
        headerName: '사용여부',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    onRowClick(param.row);
  };

  return (
    <OrderSheetList
      columns={columns}
      rows={orderSheets}
      loading={loading}
      error={error}
      handleRowClick={handleRowClick}
    />
  );
};

export default OrderSheetListContainer;
